<!-- <li class="panel"> -->
<div class="controparte">
	<div>
		<p class="col-sm-2">
			<button (click)="emitEntity(incasso)" class="btn btn-primary associa"
				type="submit">Allega</button>
		</p>
		<h4 class="titolo col-sm-3">
			{{incasso.soggettoPagatore?.parte.nominativo}}</h4>
		<p class="col-sm-3">
			<strong>Data incasso: {{incasso.dataIncasso |
				date:'dd/MM/yyyy'}}</strong>
		</p>
		<p class="col-sm-2">
			<strong>Totale: {{incasso.importo | euro}} &euro;</strong>
		</p>
	</div>
</div>
<!-- </li> -->
